import lang from 'LANG';
import { config } from 'CONFIG';
import { EPlatform, requestToApp } from '@/api/app';
import { Route } from 'vue-router';

export const headerHandle = ( to: Route ): void => {

    let name = to.name ?? 'homepage';
    if ( name === 'cancelPlan-legacy' ) {

        name = 'cancelPlan';

    }
    let nameKey = `meta.${name}`;
    if ( !lang.te( nameKey )) {

        nameKey = `meta.introduction`;

    }
    const title = lang.t( nameKey ) as string;
    if ( title ) {

        document.title = title;

    }
    if ( name === 'serviceRules' || name === 'serviceRulesTraffic' ) {

        const metaDes = lang.t( `metaDes.${name}` ) as string;
        if ( metaDes !== `metaDes.${name}` ) {

            const meta = document.getElementsByName( 'description' )[0] as HTMLMetaElement;
            meta.content = metaDes;

        }

    }

    if ( [EPlatform.Android, EPlatform.IOS].includes( config.client )) {

        requestToApp( 'modifyPageTitle', { title: title });

    }

};
